import { ListBaseModelWithAdditonalReturnInformation } from "../commonModels";

export class UserType {
    UserTypeId: number;
    Name: string;
}

export class UserTypeListModel extends ListBaseModelWithAdditonalReturnInformation {
    Items: UserType[];
}

export enum UserTypes {  
  Administration = 1,
  Service = 2,
  Customer = 3,
  ALD = 4
}
